import * as React from "react";
import type { AppPreviewGalleryInternalState } from "../next";

export const useOnBlur: (
  state: AppPreviewGalleryInternalState,
  setState: React.Dispatch<React.SetStateAction<AppPreviewGalleryInternalState>>
) => void = (state, setState) => {
  return React.useCallback(() => {
    setState({ ...state, buttonFocused: false, focused: false });
  }, [setState, state]);
};
